import { ArrowRight, CheckCircle2, Download } from "lucide-react";

const trust = ["Planning guidance grounded in the Act & Rules", "Independent audit at the end", "Data stays in India"];

export const Hero = () => (
  <section id="top" className="relative overflow-hidden pt-20 pb-16" style={{ background: "radial-gradient(1000px 500px at 50% -10%, #FDEFF1 0%, #FFF6EE 42%, transparent 68%)" }}>
    <div className="max-w-[1120px] mx-auto px-6 text-center fade-up">
      <span className="inline-flex items-center gap-2 text-[13px] font-semibold text-[#7A1426] bg-[#FBEAEE] border border-[#F3D3DB] px-3.5 py-1.5 rounded-full">
        <span className="w-1.5 h-1.5 rounded-full bg-[#9E1B32]" />
        A leadership briefing · Digital Personal Data Protection Act
      </span>
      <h1 className="mt-5 text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-tighter leading-[1.1] max-w-[880px] mx-auto">
        Getting ready for the DPDP Act,{" "}
        <span className="bg-gradient-to-r from-[#9E1B32] to-[#F58220] bg-clip-text text-transparent">and staying ready.</span>
      </h1>
      <p className="mt-6 text-base md:text-lg text-[#5C5F6B] max-w-[640px] mx-auto leading-relaxed">
        Dhwani RIS works with organisations to adopt and comply with the DPDP Act. It starts with a change in mindset, and
        ends with an audit by an independent agency.
      </p>
      <div className="mt-9 flex flex-wrap gap-3.5 justify-center">
        <a
          href="#approach"
          data-testid="hero-approach-btn"
          className="inline-flex items-center gap-2 px-6 py-3.5 rounded-[10px] bg-[#9E1B32] text-white text-[15px] font-semibold shadow-[0_4px_12px_-2px_rgba(158,27,50,0.4)] hover:bg-[#7A1426] hover:-translate-y-px transition-[background-color,transform]"
        >
          See our approach <ArrowRight size={16} />
        </a>
        <a
          href="#anumati"
          data-testid="hero-anumati-btn"
          className="inline-flex items-center gap-2 px-6 py-3.5 rounded-[10px] bg-white text-[#0B0B0F] text-[15px] font-semibold border border-[#D8D8DE] hover:bg-[#F7F7F8] transition-colors"
        >
          Explore Anumati
        </a>
        <a
          href="/Dhwani-DPDP-Approach.pptx"
          download="Dhwani-DPDP-Approach.pptx"
          data-testid="hero-download-approach-btn"
          className="inline-flex items-center gap-2 px-6 py-3.5 rounded-[10px] bg-white text-[#0B0B0F] text-[15px] font-semibold border border-[#D8D8DE] hover:bg-[#F7F7F8] transition-colors"
        >
          <Download size={16} /> Download DPDP Approach
        </a>
      </div>
      <div className="mt-6 flex flex-wrap gap-5 justify-center text-[13.5px] text-[#9498A3]">
        {trust.map((t) => (
          <span key={t} className="flex items-center gap-1.5">
            <CheckCircle2 size={15} className="text-green-600" /> {t}
          </span>
        ))}
      </div>
      <p className="mt-8 text-xs text-[#9498A3]">Based on the DPDP Act 2023 and Rules 2025 · Planning guidance, not legal advice.</p>
    </div>
  </section>
);

export default Hero;
